import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router, UrlTree } from '@angular/router';

import { AccessRight } from 'models';
import { AuthenticatedUserService } from 'services';

@Injectable()
export class MustangGuard {
    constructor(
        private authenticatedUserService: AuthenticatedUserService,
        private router: Router
    ) {}

    public canActivate(): Observable<boolean | UrlTree> {
        return this.authenticatedUserService
            .getAllowedBrands(
                AccessRight.OrderViaB2bPlatform,
                this.authenticatedUserService.user.value.organization._id
            )
            .pipe(
                map((allowedBrands) => {
                    const allowedBrandsIds = allowedBrands.map(({ _id }) => _id);
                    const mustangJeansBrandId = '5d8b83f08ebb08001209e832';
                    if (_.includes(allowedBrandsIds, mustangJeansBrandId)) {
                        return true;
                    }

                    this.router.navigate(['news']);
                    return false;
                })
            );
    }
}
